import type { UserContextAccess } from 'api/userContext';
import type { SelectedCompanySiteResult } from 'contexts/TenantSelectionContext';

/**
 * Keeps restored/selected contexts within current access, including a site-only user's parent company.
 * A sole company or site is always selected: "All" of one is the same scope, and leaving it blank
 * would show an empty picker — e.g. on first sign-in, where only the default tenant has been seeded.
 */
export function resolveContextSelection(
  access: UserContextAccess,
  selection: SelectedCompanySiteResult | null,
  chooseDefaults: boolean
): SelectedCompanySiteResult | null {
  if (!selection && access.canSelectAllCompanies && !chooseDefaults && access.companies.length !== 1) return null;
  const company = access.companies.find((item) => item.companyId === selection?.companyId) ?? access.companies[0];
  if (!company) return null;
  const site =
    company.sites.find((item) => item.siteId === selection?.siteId) ??
    (!company.canSelectAllSites || chooseDefaults || company.sites.length === 1 ? company.sites[0] : undefined);
  return {
    companyId: company.companyId,
    companyName: company.companyName,
    siteId: site?.siteId ?? null,
    siteName: site?.siteName ?? null
  };
}
